export const version: string = "15.3.12";
